import React, { useEffect, useRef, useState } from 'react';
import { Avatar } from '../../../../../components';
import LabelValueRow from '../../../../../components/LabelValueRow/LabelValueRow';
import { TableRowAccount } from '../../../../../store/deals/deals.types';
// import { FacebookIcon } from '../../../DetailedView/components/prospectData/assets/FacebookIcon';
// import { LinkediIcon } from '../../../DetailedView/components/prospectData/assets/LinkedinIcon';
// import { TwitterIcon } from '../../../DetailedView/components/prospectData/assets/TwitterIcon';

type Props = {
  account: TableRowAccount;
};

export const AccountCell: React.FC<Props> = ({
  account,
}: Props): JSX.Element => {
  const [showTooltip, setShowTooltip] = useState(false);

  const handleShowTooltip = () => {
    setShowTooltip(!showTooltip);
  };

  const nameRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = (e: MouseEvent) => {
    const target = e.target as Node;

    const isNameTarget = nameRef.current?.contains(target);

    if (!isNameTarget && showTooltip) setShowTooltip(false);
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);

    return () =>
      document.removeEventListener('click', handleClickOutside, true);
  });

  const attrs = {
    wrapper: {
      className: 'account-cell',
    },

    name: {
      wrapper: {
        className: 'account-cell__name',
        ref: nameRef,
        onMouseEnter: handleShowTooltip,
        onMouseLeave: handleShowTooltip,
      },

      tooltip: {
        wrapper: {
          className: `${showTooltip ? 'open' : ''} account-cell__name__tooltip`,
        },

        title: {
          className: 'account-cell__name__tooltip-title',
        },

        label: {
          className: 'account-cell__name__tooltip-label',
        },

        value: {
          className: 'account-cell__name__tooltip-value',
        },

        socialMedia: {
          className: 'account-cell__name__tooltip-soc-media',
        },
      },
    },

    subrowsQty: {
      className: 'account-cell-subrows-qty',
    },
  };

  const avatar = account?.name?.length ? (
    <Avatar
      userName={account.name.toUpperCase()}
      image={account?.metadata?.avatarSrc || ''}
      className="account-cell-avatar"
      engageAva
      variant="grey"
    />
  ) : null;

  const getCoordinatesForTooltip = () => {
    let xCoord = '';
    let yCoord = '';

    if (nameRef?.current?.getClientRects()?.length) {
      const { x, y } = nameRef.current.getClientRects()[0];
      xCoord = `${x}px`;
      yCoord = `${y + 27}px`;
    }
    return { xCoord, yCoord };
  };

  const { xCoord, yCoord } = getCoordinatesForTooltip();

  const subrowsQty =
    account?.subrowQty && account?.subrowQty > 1 ? (
      <div {...attrs.subrowsQty}>{account?.subrowQty}</div>
    ) : null;

  // const socialMediaRow = () => {
  //   const socialMedia = account?.metadata?.additionalData?.socialMedia;

  //   const linkedinObj = socialMedia?.find((el) => el.type === 'linkedin');

  //   const twitterObj = socialMedia?.find((el) => el.type === 'twitter');

  //   const facebookObj = socialMedia?.find((el) => el.type === 'facebook');

  //   const onIconClick = (url: string) => {
  //     if (url?.length && url.includes('http')) {
  //       window.open(`${url}`, '_blank');
  //     }
  //   };

  //   const rowToShow = (dataObj: typeof linkedinObj) => {
  //     const defineImgAndUrl = () => {
  //       let socialMediaIcon: React.FC | JSX.Element = <>No</>;

  //       let readyUrl = '';

  //       if (dataObj?.type === 'linkedin') {
  //         socialMediaIcon = <LinkediIcon />;
  //         readyUrl = `https://www.linkedin.com/${dataObj?.url}`;
  //       } else if (dataObj?.type === 'twitter') {
  //         socialMediaIcon = <TwitterIcon />;
  //         readyUrl = `https://twitter.com/${dataObj?.url}`;
  //       } else if (dataObj?.type === 'facebook') {
  //         socialMediaIcon = <FacebookIcon />;
  //         readyUrl = `https://www.facebook.com/${dataObj?.url}`;
  //       }

  //       return { socialMediaIcon, readyUrl };
  //     };

  //     const { socialMediaIcon, readyUrl } = defineImgAndUrl();

  //     return (
  //       <div
  //         className="prospect__body__row-link-img"
  //         onClick={() => onIconClick(readyUrl)}
  //       >
  //         {socialMediaIcon}
  //       </div>
  //     );
  //   };

  //   const result =
  //     linkedinObj || twitterObj || facebookObj ? (
  //       <div className="prospect__body__row">
  //         <span className="prospect__body__row-value">
  //           {linkedinObj ? rowToShow(linkedinObj) : null}
  //           {twitterObj ? rowToShow(twitterObj) : null}
  //           {facebookObj ? rowToShow(facebookObj) : null}
  //         </span>
  //       </div>
  //     ) : null;

  //   return result;
  // };

  const basicRowAttrs = {
    labelColor: '#FFFF',
    labelFontSize: '10px',
    labelFontWeight: 400,
    valueColor: '#FFFF',
    valueFontSize: '12px',
    valueFontWeight: 400,
    minWidth: '333px',
  };

  const formattedValueEmployee = account?.metadata?.employees
    ? (+account.metadata.employees)?.toLocaleString('en-US')
    : '';

  const tooltipNoData =
    !account?.metadata?.headquarters &&
    !account?.metadata?.foundedYear &&
    !account?.metadata?.employees;

  const tooltip = (
    <div
      {...attrs.name.tooltip.wrapper}
      style={
        yCoord && xCoord ? { position: 'fixed', top: yCoord, left: xCoord } : {}
      }
    >
      {tooltipNoData ? (
        `Couldn't find relevant \n company information`
      ) : (
        <>
          <LabelValueRow
            {...basicRowAttrs}
            labelFontSize="13px"
            rowHeight="35px"
            label={account?.metadata?.name || account?.name}
            hidden={!account.name}
          />
          <LabelValueRow
            {...basicRowAttrs}
            rowHeight="30px"
            label="HQ"
            value={account?.metadata?.headquarters || ''}
            hidden={!account?.metadata?.headquarters}
          />
          <LabelValueRow
            {...basicRowAttrs}
            rowHeight="30px"
            label="Year Founded"
            value={account?.metadata?.foundedYear || ''}
            hidden={!account?.metadata?.foundedYear}
          />
          <LabelValueRow
            {...basicRowAttrs}
            rowHeight="30px"
            label="Number of Employees"
            value={formattedValueEmployee}
            hidden={!account?.metadata?.employees}
          />
        </>
      )}
    </div>
  );

  const companyName = account?.metadata?.name || account?.name;

  return (
    <div {...attrs.wrapper}>
      {avatar}
      <div {...attrs.name.wrapper}>
        {companyName} {tooltip}
      </div>
      {subrowsQty}
    </div>
  );
};
